<!-- The padding is to make the drop-shadow visible -->
<div class="-mx-2 flex flex-1 overflow-hidden p-2">
  @if (loading()) {
    <div class="pointer-events-none flex-1 animate-pulse rounded-lg bg-stone-50 opacity-60"></div>
  } @else {
    <div class="flex-1 overflow-hidden rounded-lg border border-zinc-50 bg-white px-6 py-10 drop-shadow-md">
      @if (displayProduct()) {
        <!-- Product name -->
        <div class="md:h-[90px] md:overflow-hidden">
          <h3 class="text-2xl font-bold">{{ 'purchase.product.name' | transloco: { name: displayProduct()?.name } }}</h3>
          <p class="mt-2">{{ displayProduct()?.description }}</p>
        </div>

        <!-- Product price -->
        <p class="mt-6 text-xs text-stone-500">{{ 'purchase.product.price.title' | transloco }}</p>
        <div class="md:h-16">
          @if (displayProduct()?.paymentLink) {
            <p class="truncate">
              <span class="text-4xl">{{ displayProduct()?.pricePerMonth | price: displayProduct()?.currency }}</span>
              <span class="pl-2 text-sm text-stone-500">{{ 'purchase.product.price.interval_month' | transloco }}</span>
            </p>
            <p class="mt-1 truncate text-sm text-stone-500">
              @if (displayProduct()?.interval === 'year') {
                {{ 'purchase.product.price.perYear' | transloco: { amount: displayProduct()?.price | price: displayProduct()?.currency } }}
              }
            </p>
          } @else {
            <p class="flex items-center text-2xl md:h-16">{{ 'purchase.product.price.onRequest' | transloco }}</p>
          }
        </div>

        <!-- Purchase button -->
        <div class="mt-6">
          @if (displayProduct()?.paymentLink) {
            <a pButton [href]="displayProduct()?.paymentLink" class="w-full">
              <span class="font-bold">{{ 'purchase.buyBtn' | transloco }}</span>
            </a>
          } @else {
            <a pButton [href]="displayProduct()?.contactUrl" target="_blank" class="w-full">
              <span class="font-bold">{{ 'purchase.emailBtn' | transloco }}</span>
            </a>
          }
        </div>

        <!-- Product features -->
        <p class="mt-8 text-xs">{{ 'purchase.product.featuresHeadline' | transloco }}</p>
        <ul class="mt-4">
          <li *ngFor="let feature of displayProduct()?.marketingFeatures" class="relative mb-3 flex items-center whitespace-normal pl-6 text-xs">
            <i class="pi pi-check-square absolute left-0 !text-sm"></i>
            <span>{{ feature.name }}</span>
          </li>
        </ul>
      }
    </div>
  }
</div>
